import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";
import ISODateTime from "components/formatting/ISODateTime";

export interface DateOptions {
  headerLabels?: Record<string, string>;
}

function dateColumn(options?: DateOptions): GridColTypeDef {
  const dateColumn: GridColTypeDef = {
    ...baseColumn,
    type: "string",
    renderCell: (params: GridRenderCellParams) => {
      return <ISODateTime isoString={params.formattedValue} hideTime={true} />
    }
  };
  if (options?.headerLabels) {
    dateColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return dateColumn;
}

export default dateColumn;